import vueApp from './vue-app';
import './plugins';
import './theme/index.scss';

vueApp.mount('#app');
